import { type ThemeMode } from './theme-preference.service';

export interface ThemeOption {
  mode: ThemeMode;
  iconName: string;
  labelKey: string;
}

export const THEME_OPTIONS: Record<ThemeMode, ThemeOption> = {
  light: {
    mode: 'light',
    iconName: 'light-mode-toggle.svg',
    labelKey: 'theme.light-mode',
  },
  dark: {
    mode: 'dark',
    iconName: 'dark-mode-toggle.svg',
    labelKey: 'theme.dark-mode',
  },
  system: {
    mode: 'system',
    iconName: 'desktop.svg',
    labelKey: 'theme.system-mode',
  },
};
